import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl } from '@shared/helpers/form.helper';
import { cloneDeep } from 'lodash-es';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { MyAllElemLiquidatoriEntity, MyVerbale } from '../../../models/interfaces/revisione.interface';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { withCkNormeGuard } from '../common/operators/with-ck-norme-guard.operator';

const AMM_CTRL_PATH = 'my_SezioneI__Rilevazione.my_AmministrazioneControllo';

export const my_AllLiquidatoriCaricaListenerHelper = (form: FormGroup, store: Store<Revisione53State>, valoreNormaAttesa: CkNormeValues) => {
    const allElemLiquidatoriControl = getControl(form, `${AMM_CTRL_PATH}.my_AllLiquidatori.my_AllElemLiquidatori`);

    return allElemLiquidatoriControl.valueChanges
        .pipe(withChangeDebounced(allElemLiquidatoriControl), withCkNormeGuard(form, valoreNormaAttesa))
        .subscribe((liquidatori: MyAllElemLiquidatoriEntity[] = []) => {
            const liquidatoriAggiornati = liquidatori.map((liquidatore) => {
                const hasCarica = !isNilOrEmpty(liquidatore.my_AllLiquidatoriCarica);
                return {
                    ...liquidatore,
                    my_AllLiquidatoriCaricaDesc: hasCarica ? 'LIQUIDATORE' : '',
                };
            });

            allElemLiquidatoriControl.patchValue(liquidatoriAggiornati, { emitEvent: false });

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllLiquidatori.my_AllElemLiquidatori = liquidatoriAggiornati;
                return myVerbaleClone;
            });
        });
};

export const my_NumLiquidatoriListener = (form: FormGroup, store: Store<Revisione53State>): void => {
    const ctrl = getControl(form, `${AMM_CTRL_PATH}.my_AllLiquidatori.my_AllElemLiquidatori`);
    ctrl.valueChanges.pipe(withInitialValueDebounced(ctrl)).subscribe((liquidatori: MyAllElemLiquidatoriEntity[]) => {
        const value = (liquidatori?.length ?? 0).toString(10);
        getControl(form, `${AMM_CTRL_PATH}.my_NumLiquidatori`).patchValue(value, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NumLiquidatori = value;
            return myVerbaleClone;
        });
    });
};
